import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
export const LabelBoundingContainerContext = createContext(null);
export const useLabelBoundingContainerRef = () => useContext(LabelBoundingContainerContext);
export function LabelBoundingContainerProvider({ containerRef, children, }) {
    return (_jsx(LabelBoundingContainerContext.Provider, { value: containerRef, children: children }));
}
